import { Button, GridImage, LockStatus } from 'components';
import {
  KY_DATA_APPROVED_SITE_MANAGER,
  STATUS_KY_APPROVE,
  STATUS_LOCKED,
  userRole,
} from 'constant';
import { layoutSelector } from 'containers/Layout/selectors';
import { useAppDispatch } from 'hooks';
import { ConfirmDeleteModal } from 'pages/Home/Dtc/Albums/Modals';
import SectionStyled from 'pages/Home/Dtc/Albums/styles';
import { userData } from 'pages/Login/selectors';
import {
  removeImg,
  setLocationCmAgent,
  toggleCheckImg,
  updateManyImg,
} from 'pages/SiteDetail/slice';
import { deleteImage } from 'pages/SiteDetail/thunk';
import { FC, useCallback, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { GetDetailImageResponse, ImageAlbum } from 'types';
import DetailImageCM from './DetailImageCm';

type Props = {
  imagesCM: ImageAlbum[];
  loading?: boolean;
  detailImage: GetDetailImageResponse | null;
  setDetailOneImage?: (args: number) => void;
  setLoadingOneImage: (args: boolean) => void;
  loadingOneImage: boolean;
};

const AlbumsCM: FC<Props> = ({
  imagesCM,
  loadingOneImage,
  setLoadingOneImage,
  setDetailOneImage,
  detailImage,
}) => {
  const dispatch = useAppDispatch();
  const location = useLocation();

  const { LockStatusData, KYDataApproveBySiteManageDate } = useSelector(layoutSelector);
  const [showChecked, setShowChecked] = useState(false);
  const [dataModalImage, setDataModalImage] = useState<ImageAlbum | null>(null);
  const [visibleModalDelete, setVisibleModalDelete] = useState(false);
  const [visibleModalImage, setVisibleModalImage] = useState(false);
  const { roleUser } = useSelector(userData);
  const listIdImageSelected = useMemo(
    () => imagesCM.filter(({ isSelected }) => isSelected).map(({ image_id }) => image_id),
    [imagesCM]
  );
  const handleSelect = useCallback(
    (id: number, isSelected: boolean) => {
      dispatch(toggleCheckImg({ id, isSelected }));
      dispatch(setLocationCmAgent(location.state));
    },
    [dispatch, location]
  );
  const handleClickImage = useCallback(
    async (image: ImageAlbum) => {
      try {
        setLoadingOneImage(true);
        if (setDetailOneImage) {
          setDetailOneImage(image.image_id);
        }
        !showChecked && setVisibleModalImage(true);
        setDataModalImage(image);
        setTimeout(() => setLoadingOneImage(false), 4000);
      } catch (e) {
        setLoadingOneImage(false);
      }
    },
    [setDetailOneImage, setLoadingOneImage, showChecked]
  );

  const handleDelete = () => {
    const deleteImageId = imagesCM
      .filter(({ isSelected }) => isSelected)
      .map((value) => {
        return {
          image_id: Number(value.image_id),
        };
      });
    const listImgDelete = deleteImageId && deleteImageId.map((item) => item.image_id);
    dispatch(deleteImage({ images: deleteImageId })).then(() => {
      dispatch(removeImg({ ids: listImgDelete }));
    });
    setVisibleModalDelete(false);
  };

  return (
    <SectionStyled>
      <div className="container">
        <LockStatus
          text={LockStatusData?.site_name}
          roleStatus={{
            text:
              KYDataApproveBySiteManageDate?.[
                userRole.DTC === roleUser
                  ? `site_director_approval_flag`
                  : `site_manager_approval_flag`
              ] === KY_DATA_APPROVED_SITE_MANAGER.true
                ? 'RKY承認済'
                : 'RKY未承認',
            lock:
              KYDataApproveBySiteManageDate?.[
                userRole.DTC === roleUser
                  ? `site_director_approval_flag`
                  : `site_manager_approval_flag`
              ] === STATUS_KY_APPROVE.true,
          }}
          lockStatus={{
            text: LockStatusData?.status_locked === STATUS_LOCKED.true ? '施錠済' : '未施錠',
            lock: LockStatusData?.status_locked === STATUS_LOCKED.true,
          }}
          code={LockStatusData?.building_code}
        />
        <div className="header">
          <Button
            className="btn-chose-img btn"
            onClick={() => {
              const dataSetFalseListIdImageSelected = listIdImageSelected.map((item) => ({
                id: item,
                changes: { isSelected: false },
              }));
              dataSetFalseListIdImageSelected.length > 0 &&
                dispatch(updateManyImg({ data: dataSetFalseListIdImageSelected }));
              setShowChecked(!showChecked);
            }}
          >
            {showChecked ? '選択をキャンセル' : '写真を選択する'}
          </Button>
          {showChecked && (
            <>
              <div className="box-action">
                <Button
                  className="btn-delete btn"
                  disabled={listIdImageSelected.length <= 0}
                  onClick={() => setVisibleModalDelete(true)}
                >
                  削除
                </Button>
              </div>
            </>
          )}
        </div>
        {!!imagesCM.length && (
          <GridImage
            data={imagesCM}
            showChecked={showChecked}
            onSelect={handleSelect}
            onClickImage={handleClickImage}
          />
        )}
      </div>
      <ConfirmDeleteModal
        visible={visibleModalDelete}
        onOk={() => {
          handleDelete();
          setVisibleModalDelete(false);
        }}
        onCancel={() => setVisibleModalDelete(false)}
      />
      <DetailImageCM
        detailImage={detailImage}
        data={dataModalImage}
        visible={visibleModalImage}
        setVisibleModalImage={setVisibleModalImage}
        images={imagesCM}
        setLoadingOneImage={setLoadingOneImage}
        loadingOneImage={loadingOneImage}
      />
    </SectionStyled>
  );
};

export default AlbumsCM;
